import { ApiClient } from "~/clApi/main/foundation/ApiClient"
import { SwCorporationAccountListView } from "~/clApi/viewModel/swCorporationAccount"

const basePath = "/corporation_account/user/sw_corporation_account"

export const read = {
  getSwCorporationAccountList: () =>
    new ApiClient<SwCorporationAccountListView>().get(`${basePath}/list`),
}
